/**
 * assets/spirituosen.js
 * No 7 Augsburg - Spirituosen-Landingpage
 * Analog zur Weinserien-Vorlage, ohne Staffelpreise.
 * Grundpreispflicht: EUR / 1 l
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     Hilfsfunktionen
  ───────────────────────────────────────────────────────────── */

  /** Cent-Betrag zu deutschem Preisstring formatieren */
  window.n7spFormatMoney = function (cents) {
    var eur = (cents / 100).toFixed(2).replace('.', ',');
    return eur + '\u00a0\u20ac';
  };

  /** Grundpreis berechnen und formatieren (EUR pro 1 l) */
  window.n7spFormatBasePrice = function (cents, volLiters) {
    if (!volLiters || volLiters <= 0) return '';
    var perLiter = (cents / 100) / volLiters;
    var formatted = perLiter.toFixed(2).replace('.', ',');
    return formatted + '\u00a0\u20ac\u00a0/\u00a01\u00a0l';
  };

  /* ─────────────────────────────────────────────────────────────
     Grundpreise in jede Zeile rendern
  ───────────────────────────────────────────────────────────── */
  window.n7spRenderPriceBlocks = function () {
    var rows = document.querySelectorAll('.n7sp-row');
    if (!rows.length) return;

    for (var ri = 0; ri < rows.length; ri++) {
      var row        = rows[ri];
      var priceCents = parseInt(row.getAttribute('data-price') || '0', 10);
      var vol        = parseFloat(row.getAttribute('data-vol') || '0');
      var prodId     = row.getAttribute('data-product-id') || '';

      var buyCol = document.getElementById('n7sp-buy-' + prodId);
      if (!buyCol) continue;

      var baseEl = buyCol.querySelector('.n7sp-base-price');
      if (baseEl && vol > 0) {
        baseEl.textContent = window.n7spFormatBasePrice(priceCents, vol);
      }
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Aktuell gewaehlte Menge einer Zeile ermitteln
  ───────────────────────────────────────────────────────────── */
  window.n7spGetQty = function (prodId) {
    var input = document.getElementById('n7sp-qty-' + prodId);
    if (!input) return 1;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    return q;
  };

  /* ─────────────────────────────────────────────────────────────
     Cart Drawer oeffnen
  ───────────────────────────────────────────────────────────── */
  window.n7spOpenCartDrawer = function () {
    var triggers = document.querySelectorAll('[aria-controls="site-cart-sidebar"]');
    for (var i = 0; i < triggers.length; i++) {
      var rect = triggers[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        triggers[i].click();
        return true;
      }
    }
    var sidebarEl = document.querySelector('sidebar-drawer#site-cart-sidebar');
    if (sidebarEl && typeof sidebarEl.show === 'function') {
      sidebarEl.show();
      return true;
    }
    return false;
  };

  /* ─────────────────────────────────────────────────────────────
     Cart Drawer aktualisieren (body + footer + header + Header-Button)
  ───────────────────────────────────────────────────────────── */
  window.n7spUpdateCartDrawer = function () {
    return fetch('/cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser      = new DOMParser();
        var doc         = parser.parseFromString(html, 'text/html');
        var fetchedCart = doc.querySelector('sidebar-drawer#site-cart-sidebar');
        var sidebarEl   = document.querySelector('sidebar-drawer#site-cart-sidebar');

        if (sidebarEl && fetchedCart) {
          /* sidebar__body: Artikel-Liste */
          var newBody  = fetchedCart.querySelector('.sidebar__body');
          var bodyEl   = sidebarEl.querySelector('.sidebar__body');
          if (bodyEl && newBody) { bodyEl.innerHTML = newBody.innerHTML; }

          /* sidebar__footer: Gesamtbetrag (AjaxCartSubtotal) */
          var newFooter = fetchedCart.querySelector('.sidebar__footer');
          var footerEl  = sidebarEl.querySelector('.sidebar__footer');
          if (footerEl && newFooter) { footerEl.innerHTML = newFooter.innerHTML; }

          /* sidebar__header: Zaehler im Drawer-Titel */
          var newHeader = fetchedCart.querySelector('.sidebar__header');
          var headerEl  = sidebarEl.querySelector('.sidebar__header');
          if (headerEl && newHeader) { headerEl.innerHTML = newHeader.innerHTML; }

          var cartForm = sidebarEl.querySelector('cart-form');
          if (cartForm && typeof cartForm.ajaxifyCartItems === 'function') {
            cartForm.ajaxifyCartItems();
          }
        }

        /* Header-Button AUSSERHALB des Drawers aktualisieren */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var fmt = (cart.total_price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
              el.textContent = fmt;
            });
          });

        window.n7spOpenCartDrawer();
      })
      .catch(function (err) {
        console.warn('[n7sp] Cart-Drawer-Fehler:', err);
      });
  };

  /* ─────────────────────────────────────────────────────────────
     Event-Handler: Mengen-Buttons, Add-to-Cart, Mehr-lesen
  ───────────────────────────────────────────────────────────── */
  window.n7spBindEvents = function () {
    var page = document.getElementById('n7-spirituosen-page');
    if (!page || page.getAttribute('data-n7sp-bound') === '1') return;
    page.setAttribute('data-n7sp-bound', '1');

    page.addEventListener('click', function (e) {

      /* Mengen-Buttons */
      var qtyBtn = e.target.closest('.n7sp-qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var wrap  = qtyBtn.closest('.n7sp-qty-wrap');
        var input = wrap ? wrap.querySelector('.n7sp-qty-input') : null;
        if (!input) return;
        var cur = parseInt(input.value, 10);
        if (isNaN(cur) || cur < 1) cur = 1;
        var action = qtyBtn.getAttribute('data-qty-action');
        if (action === 'plus') { cur += 1; }
        if (action === 'minus' && cur > 1) { cur -= 1; }
        input.value = cur;
        return;
      }

      /* Mehr lesen / Weniger */
      var rm = e.target.closest('.n7sp-intro__readmore');
      if (rm) {
        e.preventDefault();
        var desc = document.getElementById('n7sp-intro-desc');
        if (!desc) return;
        var expanded = desc.classList.toggle('n7sp-intro__desc--expanded');
        rm.innerHTML = expanded ? 'Weniger anzeigen \u2039' : 'Mehr lesen \u203a';
        return;
      }

      /* In den Warenkorb */
      var btn = e.target.closest('.n7sp-add-cart-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      var prodId    = btn.getAttribute('data-product-id');
      if (!variantId) return;

      var qty = window.n7spGetQty(prodId);

      btn.classList.add('n7sp-loading');
      var origLabel = btn.textContent;
      btn.textContent = 'Wird hinzugef\u00fcgt\u2026';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (errData) {
              throw new Error(errData.description || ('cart/add.js: ' + r.status));
            });
          }
          return r.json();
        })
        .then(function () {
          btn.classList.remove('n7sp-loading');
          btn.classList.add('n7sp-added');
          btn.textContent = 'Hinzugef\u00fcgt \u2714';

          window.n7spUpdateCartDrawer();

          setTimeout(function () {
            btn.classList.remove('n7sp-added');
            btn.textContent = 'In den Warenkorb';
          }, 2200);
        })
        .catch(function (err) {
          console.warn('[n7sp] cart/add.js Fehler:', err);
          btn.classList.remove('n7sp-loading');
          btn.textContent = origLabel || 'In den Warenkorb';
        });
    });

    /* Direkte Eingabe ins Mengenfeld */
    page.addEventListener('input', function (e) {
      var input = e.target.closest('.n7sp-qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) { input.value = 1; }
    });
  };

  /* ─────────────────────────────────────────────────────────────
     "Mehr lesen" nur zeigen wenn Text abgeschnitten
  ───────────────────────────────────────────────────────────── */
  window.n7spSetupReadmore = function () {
    var desc = document.getElementById('n7sp-intro-desc');
    var btn  = document.getElementById('n7sp-readmore');
    if (!desc || !btn) return;
    if (desc.scrollHeight <= desc.clientHeight + 4) {
      btn.style.display = 'none';
      desc.classList.add('n7sp-intro__desc--expanded');
    } else {
      btn.style.display = '';
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Init
  ───────────────────────────────────────────────────────────── */
  window.n7spInit = function () {
    if (!document.getElementById('n7-spirituosen-page')) return;
    window.n7spRenderPriceBlocks();
    window.n7spBindEvents();
    window.n7spSetupReadmore();
  };

  window.n7spInit();

  document.addEventListener('DOMContentLoaded', function () {
    window.n7spInit();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#n7-spirituosen-page')) {
      window.n7spInit();
    }
  });

}());